import React from 'react';
import { vacancyApi } from '@cp/entities/vacancy';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { CAREER_IDS_WITH_CHILDREN_PARAMETER } from '@common/const/catalog/item';
import { DEFAULT_LANGUAGE_CODE } from '@common/const/localization';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { AppFormProvider } from '@cp/utils/form';
import { useClientCity } from 'src/app/shared/hooks/useClientCity';
import { useClientProfile } from 'src/entities/client';
import { EButtonName, useTracking } from 'src/shared/tracking';
// FIXME sibling import
import { useSubscriptionInterceptor } from 'src/features/billing';
import { VacancyForm, VacancyFormProps } from '../form';
import { Header } from '../header';
import { VacancyEvents, contentContanerSx } from '../../lib';
import { CHILD_DEFAULT_AGE, IVacancyCreationFormInitialValues, useVacancyForm } from '../../model';

export interface NewProps
  extends Pick<
    VacancyFormProps,
    | 'submitButtonTitle'
    | 'secondaryButtonTitle'
    | 'buttonsInsideFormContainer'
    | 'secondaryButtonIsAlwaysVisible'
    | 'submitButtonProps'
    | 'secondaryButtonProps'
  > {
  initialValues: IVacancyCreationFormInitialValues;
  onGoBack: () => void;
  header?: React.ReactNode;
}

export const New: React.FC<NewProps> = ({ initialValues, onGoBack, header, ...restProps }) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  // TODO: discus to get profile from props. It allows to edit not only current client catalog and useful for admin
  const clientProfile = useClientProfile();
  const { clientCity, isLoading: isLoading } = useClientCity();
  const trackSubmitClick = useTracking(VacancyEvents.VacancyPublish);
  const submit = React.useCallback<VacancyFormProps['onSubmit']>(
    (values) => {
      trackSubmitClick(values.careerId);
      return dispatch(vacancyApi.endpoints.createVacancyForCurrentClient.initiate(values));
    },
    [dispatch, trackSubmitClick],
  );
  const handleSubmit = useSubscriptionInterceptor(submit);
  const { address, location } = clientProfile ?? {};
  const form = useVacancyForm({
    children: CAREER_IDS_WITH_CHILDREN_PARAMETER.includes(initialValues.careerId || 1) ? [{ age: CHILD_DEFAULT_AGE }] : undefined,
    translations: [{ languageCode: DEFAULT_LANGUAGE_CODE }],
    address: address && location ? { address, location } : undefined,
    ...initialValues,
    city: clientCity,
  });

  if (isLoading) {
    return <ContentSkeleton blocks={2} />;
  }

  if (!clientCity) {
    return null;
  }

  return (
    <AppFormProvider form={form}>
      {header ?? <Header careerId={initialValues.careerId || 1} />}
      <VacancyForm
        contentContainerSx={contentContanerSx}
        onComplete={onGoBack}
        onSecondaryButtonClick={onGoBack}
        onSubmit={handleSubmit}
        secondaryButtonIsAlwaysVisible
        secondaryButtonTitle="Пропустить"
        submitButtonProps={{ className: EButtonName.PublishVacancy }}
        submitButtonTitle="Опубликовать"
        {...restProps}
      />
    </AppFormProvider>
  );
};
